var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-page"},[_c('div',{staticClass:"lbar loading-bar1"}),_c('div',{staticClass:"lbar loading-bar2"}),_c('div',{staticClass:"lbar loading-bar3"}),_c('div',{staticClass:"lbar loading-bar4"}),_c('div',{staticClass:"lbar loading-bar5"})])
}]

export { render, staticRenderFns }